<template>
  <div class="mem-edit">
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
      <FormItem label="会员昵称">
        <Tag
          type="border"
          closable
          v-for="user in formValidate.users"
          :key="user.uid"
          @on-close="UserDelete(user.uid)"
        >{{user.nickname}}</Tag>
        <Button type="default" @click="showSelectUser=true">
          <i class="ivu-icon ivu-icon-ios-add"></i>选择用户
        </Button>
      </FormItem>
      <FormItem label="手机号码">
        <Input disabled v-model="mobile" style="width: 300px;"></Input>
      </FormItem>
      <FormItem label="赠送会员计划" prop="vip_grade_id">
        <Select v-model="formValidate.vip_grade_id" placeholder="请选择" style="width: 300px;">
          <Option
            v-for="(item,index) in vipGrade"
            :key="index"
            :value="item.vip_grade_id"
          >{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem style="text-align:center">
        <Button size="large" :to="{name: 'MemberManage'}">返回</Button>
        <Button
          size="large"
          style="margin: 0 15px;"
          type="primary"
          @click="submits('formValidate')"
        >保存并返回</Button>
      </FormItem>
    </Form>
    <Modal
      class="grid-select"
      v-model="showSelectUser"
      title="选择用户"
      @on-ok="confirmSelectUser"
      @on-cancel="$refs.user.recoverSelectedItems(formValidate.users)"
      width="800"
      scrollable
    >
      <StudentSelect
        selectType="single"
        ref="user"
        data-url="/api/userChose"
        :selectedItems="formValidate.users"
      ></StudentSelect>
    </Modal>
  </div>
</template>

<script>
import StudentSelect from "@/components/GridSelect/StudentSelect";
export default {
  name: "MemberEdit",
  components: {
    StudentSelect
  },
  data() {
    return {
      mobile: "",
      formValidate: {
        users: [],
        vip_grade_id: ""
      },
      ruleValidate: {
        vip_grade_id: [
          { required: true, type: "number", message: "请选择计划" }
        ]
      },
      showSelectUser: false,
      vipGrade: []
    };
  },
  async created() {
    await this.getvipGrade();
  },
  methods: {
    async getvipGrade() {
      let data = await this.$http.get("/api/vipGrade", { grade_type:2,status:1,limit: 100 });
      this.vipGrade = data.list;
    },
    UserDelete(id) {
      let users = this.formValidate.users;
      for (let i = 0; i < users.length; i++) {
        if (users[i].uid == id) {
          users.splice(i, 1);
          this.mobile = "";
          break;
        }
      }
    },
    confirmSelectUser() {
      this.showSelectUser = false;
      let list = this.$refs.user.getSelectList();
      this.formValidate.users = list;
      this.mobile = list[0].mobile;
    },
    submits(name) {
      this.$refs[name].validate(async valid => {
        if (!valid) {
          return;
        }
        let obj = {
          uid: this.formValidate.users[0].uid,
          vip_grade_id: this.formValidate.vip_grade_id
        };
        await this.$http.post("/api/vipUser", obj);
        this.$Message.saveSuccess();
        this.$router.push({
          name: "MemberManage"
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.mem-edit {
  padding: 20px;
}
</style>

